<div class="container">
  <app-titulo>Empresas Faturadas</app-titulo>
  <app-subtitulo>
    Selecione uma empresa para associar no seu faturamento.
  </app-subtitulo>
  <form [formGroup]="form">
      <app-input
          type="select"
          label="Nome da Empresa"
          name="NM_EPSA"
          formControlName="NM_EPSA"
          width="200%"
          placeholder="Selecione"
          [requiredInput]="true"
          [selectData]="empresaOptions"
          (ngModelChange)="escolherEmpresa($event)"></app-input>
  </form>
  <!-- <div class="tabela">
    <app-tabela-form
      *ngIf="!isLoading && tableData.length"
      [data]="tableData"
      [columns]="tableColumns"></app-tabela-form>
    <h2 *ngIf="!isLoading && !tableData.length">Pesquise o nome da empresa</h2>
  </div> -->
  <div class="buttons">
    <app-botao
      text="Cancelar"
      color="#27272A"
      bgColor="#F8FAFC"
      border="1px solid #D1D5DB"
      (click)="onCancelar()" />
    <app-botao
      text="Confirmar"
      [bgColor]="!form.valid ? '#D1D5DB' : '#557DAE'"
      border="1px solid #D1D5DB"
      (click)="postEmpresaFaturada()"
      [disabled]="!form.valid" />
  </div>
</div>

<app-loader [isLoading]="isLoading"></app-loader>
